<div
  class="fixed bottom-0 left-64 right-0 flex items-center justify-between px-4 py-[9px] shadow-banner"
  [ngClass]="{
    'bg-aux-green-light-1': !disabled,
    'bg-aux-gray-light-1': disabled,
  }"
>
  @if (!disabled) {
    <div class="font-semibold text-aux-blue-dark-1">
      You completed the Closing Checklist! Click here to continue to Close Summary to close the
      month.
    </div>
  } @else {
    <div class="font-semibold text-aux-gray-darkest">
      Once Checklist is complete, click here to continue to Close Summary to close the month.
    </div>
  }

  <div class="flex">
    <aux-assign-month-close />

    <span
      [auxTooltip]="disabled ? 'To continue, complete the checklist above.' : ''"
      [ngClass]="{ 'cursor-not-allowed': disabled }"
    >
      <span
        class="btn ml-4 h-[40px] min-w-[206px] whitespace-nowrap text-sm font-bold"
        [ngClass]="{
          'btn--success cursor-pointer': !disabled,
          'pointer-events-none border-aux-gray-light-2 bg-aux-gray-light-2 text-aux-gray-dark-1':
            disabled,
        }"
        [routerLink]="routerLink"
      >
        Continue to Close Month
      </span>
    </span>
  </div>
</div>
